export default "__VITE_ASSET__BxnT_U3F__"